import { BaseQueryFn, createApi } from '@reduxjs/toolkit/query/react';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import {
  GetCoverageLabelsResponseData,
  GetCoveragePatchesResponseData,
} from '@larki/mp/lib/coverage';

const baseApi = axios.create({
  baseURL: `${process.env.LARKI_ENGINE_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});
type LarkiBaseQueryFnArgs = {
  url: string;
  method?: AxiosRequestConfig['method'];
  data?: AxiosRequestConfig['data'];
  params?: AxiosRequestConfig['params'];
  headers?: AxiosRequestConfig['headers'];
};
function engineApiBaseQuery<T>(): BaseQueryFn<
  LarkiBaseQueryFnArgs,
  T,
  AxiosError | Error
> {
  return async ({ url, method, data, params, headers }) => {
    try {
      const resp = await baseApi({ url, method, data, params, headers });
      return { data: resp.data };
    } catch (error) {
      if (error instanceof AxiosError) {
        return { error };
      }
      return { error: new Error('server error') };
    }
  };
}

export const rtkEngineApi = createApi({
  reducerPath: 'engine',
  baseQuery: engineApiBaseQuery(),
  endpoints: (build) => ({
    getCoveragePatches: build.mutation<
      GetCoveragePatchesResponseData,
      {
        shapes: EngineShapeInput[];
        ignore_patches: number[];
      }
    >({
      query: (data) =>
        ({
          url: '/coverage/v3/patches',
          method: 'POST',
          data,
        }) satisfies LarkiBaseQueryFnArgs,
    }),

    getCoverageLabels: build.mutation<
      GetCoverageLabelsResponseData,
      {
        shapes: EngineShapeInput[];
        min_area: number;
      }
    >({
      query: (data) =>
        ({
          url: '/coverage/v3/labels',
          method: 'POST',
          data,
        }) satisfies LarkiBaseQueryFnArgs,
    }),
  }),
});

export const { useGetCoveragePatchesMutation, useGetCoverageLabelsMutation } =
  rtkEngineApi;

type EngineShapeInput = GeoJSON.Feature<
  GeoJSON.Polygon | GeoJSON.MultiPolygon,
  {
    id: string;
    category_name: string;
    base_shape_id: string | null;
    hidden: boolean;
  }
>;
